import moment from 'moment';
import 'moment/locale/pt-br';
moment.locale('pt-br');

export const returnDate = (data) => {
    if (!data) return '';

    const now = moment();
    const inputDate = moment(data);

    const diffInHours = now.diff(inputDate, 'hours');
    const diffInDays = now.diff(inputDate, 'days');

    if (diffInDays === 0) {
        if (diffInHours < 1) return moment(data).fromNow(); // ex: "há 5 minutos"
        if (diffInHours < 12) return `${diffInHours} horas atrás`;
        return 'Hoje';
    }

    if (diffInDays === 1) return 'Ontem';

    if (diffInDays < 7) {
        return `${inputDate.format('dddd')} - ${inputDate.format('D [de] MMMM')}`;
    }

    return inputDate.format('DD/MM/yyyy');
};

export function formatLocalDate(localDateStr) {
    if (!localDateStr) return "";
    const [year, month, day] = localDateStr.split("-");
    return `${day}/${month}/${year}`;
}